import { Injectable } from '@angular/core';
import
{
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuardService implements CanActivate
{
  constructor(
    private permissionsService: NgxPermissionsService,
    private router: Router) { }

  public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean>
  {
    const requiredPermissions = route.data.permissions.only || [];
    const hasPermission = await this.permissionsService.hasPermission(requiredPermissions);
    if (!hasPermission)
    {
      this.router.navigate(['/not-found']);
      return false;
    }
    return true;
  }
}
